import React, { useEffect, useRef, useState } from "react";
import "./CardFourScreen.css";
import meImage from "../../assets/me.png";

export default function CardFourScreen() {
  const imageRef = useRef<HTMLImageElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="card-four-screen">
      <div className="card-four-content">
        <div className="card-four-image">
          <img
            ref={imageRef}
            src={meImage}
            alt="Tatev"
            className={`profile-image ${isVisible ? "fade-in" : ""}`}
          />
        </div>

        <div className="card-four-text">
          <h1 className="card-four-title">Բարև, ես Տաթևն եմ։</h1>
          <p className="card-four-description">
            Ես ծրագրավորող եմ, ով իր մշտական աշխատանքից բացի զբաղվում է իր կապիտալի աճեցմամբ։ Ես չունեմ ֆինանսական կրթություն և արտոնություն Ձեզ ֆինանսական խորհուրդ տալու։
            <br />
            Ես հավատում եմ, որ ֆինանսական կրթությունը պետք է անվճար լինի, և կիսվում եմ իմ գիտելիքով մի քանի օնլայն հարթակներում։
          </p>
        </div>
      </div>
    </div>
  );
}
